import { EntityLayout } from "@backstage/plugin-catalog";

import overviewContent from "../common/overviewContent";

export default (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      {overviewContent}
    </EntityLayout.Route>
  </EntityLayout>
);
